export const FILES_FILTER = "FILES_FILTER"
export const FILES_FILTER_SUCCESS = "FILES_FILTER_SUCCESS"
export const FILES_FILTER_ERROR = "FILES_FILTER_ERROR"

export const FILES_SEGMENTS = "FILES_SEGMENTS"
export const FILES_SEGMENTS_SUCCESS = "FILES_SEGMENTS_SUCCESS"
export const FILES_SEGMENTS_ERROR = "FILES_SEGMENTS_ERROR"

export const FILES_LIST = "FILES_LIST"
export const FILES_LIST_SUCCESS = "FILES_LIST_SUCCESS"
export const FILES_LIST_ERROR = "FILES_LIST_ERROR"

export const FILES_PROCESS_REFRESH = "FILES_PROCESS_REFRESH"
export const FILES_SLIP_QR_UPDATE = "FILES_SLIP_QR_UPDATE"

export const FILES_DOWNLOAD = "FILES_DOWNLOAD"

export const FILES_SLIP_MKSOFT_DOWNLOAD = "FILES_SLIP_MKSOFT_DOWNLOAD"
export const FILES_INVOICE_ISSUED_MKSOFT_DOWNLOAD = "FILES_INVOICE_ISSUED_MKSOFT_DOWNLOAD"
export const FILES_INVOICE_DELIVERED_MKSOFT_DOWNLOAD = "FILES_INVOICE_DELIVERED_MKSOFT_DOWNLOAD"
